import { Component } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {TranslateService} from "@ngx-translate/core";

import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { AsyncPipe } from "@angular/common";
//import { appConfig } from './app.config';

import 'leaflet';
import 'leaflet.markercluster';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    imports: [IonApp, IonRouterOutlet, TranslateModule, AsyncPipe]
})
export class AppComponent {
  constructor() {}
  /*
  constructor(private translate: TranslateService) {
    this.translate.addLangs(['ca', 'es', 'en', 'fr']);
    this.translate.setDefaultLang('ca');
    this.translate.use('ca');
  }
    */  
}
